
import React, { useContext, useEffect, useRef, useState } from "react";

import { Button, Checkbox, Col, Form, Input, Modal, Row, Typography } from "antd";
import { CalendarOutlined, DollarOutlined, PhoneOutlined, CheckCircleTwoTone, PhoneFilled } from "@ant-design/icons";

import { CallbackMessage } from "../../../CallbackMessage/web";
import { ConfigStateContext } from "../../../../Contexts/Configurations/context";
import { Grid } from "antd";
import { LeadButtons } from "../LeadButtons/web";
import { RTBhouse } from "../../../RTBhouse/web";
import { Rule } from "antd/lib/form";
import SimilarsLead from "../SimilarsLead/web";
import cookie from "js-cookie";
import { isValidCharactersXSS } from "../../../../Utils/Functions";
import { openAuthModal } from "../../../../Components/User/AuthModal/openAuthModal";
import { useContact } from "../hook";
import { useFacebookPixel } from "../../../../GlobalHooks/web/FacebookPixel.hook";
import { useGoogleAnalytics } from "../../../../GlobalHooks/web/GoogleAnalytics.hook";
import { useRouter } from "next/router";
import { useTheme } from "../../../../Styles/ThemeHook";
import { useUser } from "../../../User/User.hook";
import getConfig from "next/config";
import { ModalState, ModalStatus } from "./type";
const { NODE_ENV } = getConfig().publicRuntimeConfig;

const { useBreakpoint } = Grid;

const { TextArea } = Input;


interface ContactInput {
	property_id: number;
	source: number;
	type: string;
	financing_information: boolean;
	message?: string;
	visit_type?: string;
	date?: string;
	utm_args?: UtmArgs;
	isAutoGenerated?: boolean;
	onlyConsult?: boolean;
	queryRouter?: string;
}

interface UtmArgs {
	utm_content?: string | string[];
	utm_source?: string | string[];
	utm_medium?: string | string[];
	utm_campaign?: string | string[];
}

export const TextForm = ({
	id,
	onComplete = null,
	form,
	identifier,
	mode,
	disabled = false,
	defaultMessage = "",
	isInListing = false,
	showCTA = false,
	onlyConsult = false,
	queryRouter,
	isProjectSpecialPage = false,
	slug = "",
	projectId = null,
	isFromPaidTraffic = null,
}) => {
	const Router = useRouter();

	const { user } = useUser();
	const { theme } = useTheme();
	const { country_code } = useContext(ConfigStateContext);
	const bell = useRef(null);
	const [modalState, setModalState] = useState<ModalStatus>({
		similarModal: ModalState.DEFAULT,
		contactLead: ModalState.DEFAULT,
	}); const [isLoading, setIsLoading] = useState(false);
	const [formType, setFormType] = useState<number>(0);
	// Simula el click de CTA "Avisame cuando baje de precio"
	useEffect(() => {
		setTimeout(() => {
			if (queryRouter && queryRouter === "bell") {
				if (bell.current) bell.current.click();
			}
		}, 3000);
	}, [queryRouter]);

	const openModal = (type: number = 0) => {
		if (onComplete) onComplete();

		setFormType(type);
		setModalState(prevState => ({ ...prevState, similarModal: ModalState.OPEN }));
	};

	const screen = useBreakpoint();

	const {
		contactMutation,
		sendContact,
		resetForm,
		loading,
		error,
		formCompleted,
		disabledEmail,
		dataRegisterMutation,
		dataUserExist,
		updateUser,
		doContactMutation,
		leadID,
		isSendedConsultation
	} = useContact({
		id,
		onComplete: openModal,
		type: "lead",
		mode,
		source: isInListing ? 22 : screen.lg ? 0 : 4,
		utm: Router.query,
		env: NODE_ENV == "development" || NODE_ENV == "beta" ? "development" : "production",
	});

	const GA = useGoogleAnalytics();
	const FP = useFacebookPixel();

	const reset = () => {
		resetForm();
		form.setFieldsValue({
			nombre: user.data?.me?.name,
			telefono: user.data?.me?.phone,
			email: user.data?.me?.email,
			financing_information: false,
			mensaje: "",
		});
		setIsLoading(false);
	};

	useEffect(() => {
		Router.events.on("routeChangeStart", reset);
		return () => Router.events.on("routeChangeStart", reset);
	}, []);

	useEffect(() => {
		if (user.data) {
			form.setFieldsValue({
				nombre: user.data?.me?.name,
				telefono: user.data?.me?.phone,
				email: user.data?.me?.email,
			});
		}
	}, [user]);

	// Aqui capturo los errores de la query de userExistsQuery
	useEffect(() => {
		if (error && error.message.includes("ya se encuentra registrada")) {
			CallbackMessage({
				message: error.message,
				type: "error",
			});

			setIsLoading(false);
		}
	}, [error]);

	useEffect(() => {
		if (formCompleted) {
			const categoryName: string = "formulario";

			GA.Event({
				category: categoryName,
				action: "formulario ic2",
				label: "text form",
				value: 1,
			});

			FP.StandardEvent("CompleteRegistration");
		}
	}, [formCompleted]);

	useEffect(() => {
		if (dataRegisterMutation) {
			refreshAuth(dataRegisterMutation.registerIndividual);
		}
	}, [dataRegisterMutation]);

	useEffect(() => {
		if (dataUserExist) {
			openAuthModal({
				withPromise: true,
				email: form.getFieldsValue().email,
			})
				.then(_ => {
					setCurrentUser(form.getFieldsValue().name, form.getFieldsValue().phone);
				})
				.catch(_ => {
					setIsLoading(false);
					//if(onComplete) onComplete();
				});
		}
	}, [dataUserExist]);

	const setCurrentUser = (name: string, phone: string, type: number = 0) => {
		updateUser({
			name: name,
			phone: phone,
		}).then(_ => {
			doContactMutation(type);
		});
	};

	const setTypeCTA = (type: number) => {
		doContactMutation(type);
	};

	const refreshAuth = data => {
		cookie.set("frontend_token", data.access_token, { expires: 365 });
		localStorage.setItem("user_md5", data.user_md5);
		user.refetch();
	};

	const validateMessages = {
		required: "El ${label} es requerido!",
		types: {
			email: "El ${label} no es válido!",
			number: "El ${label} no es un número válido!",
		},
	};

	const customResValidator = (value: string, label: string): Promise<void> => {
		if (typeof value == "undefined" || !value.trim())
			return Promise.reject(new Error(`El ${label} es requerido!`));

		return isValidCharactersXSS(value) || value == ""
			? Promise.resolve()
			: Promise.reject(new Error(`${label} no válido`));
	};

	const UY_TELEPHONE = "^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-s./0-9]*$";
	const BR_TELEPHONE = "^[0-9]{10,11}$";

	const validateRules: { [x: string]: Rule[] } = {
		nombre: [
			{
				validator(_, name) {
					return customResValidator(name, "Nombre");
				},
			},
		],
		telefono: [
			{
				required: true,
				pattern: new RegExp(country_code === "BR" ? BR_TELEPHONE : UY_TELEPHONE),
				message: "Teléfono no válido",
			},
		],
		email: [{ required: true, type: "email" }],
		mensaje: [
			{
				validator: async (_, message) => {
					return customResValidator(message, "Mensaje");
				},
			},
		],
	};

	const submitForm = () => {
		form.validateFields()
			.then(values => {
				values.nombre = values.nombre.trim();
				values.mensaje = values.mensaje.trim();
				values.isFromPaidTraffic = isFromPaidTraffic;
				values.isSendingConsultation = true;
				sendContact({ ...values });
				setIsLoading(true);
				if (isProjectSpecialPage && slug && projectId) {
					let host = window.location.host;
					let TEST_HOST = "xn--4v8h.infocasas.com.uy";
					if (host === TEST_HOST || host === "localhost:3000") {
						host = "beta.infocasas.com.uy";
					}
					let reqEndpoint = `https://${host}/?mid=proyectos&func=landingDinamica&slug=${slug}&formulario&IDproyecto=${projectId}&json&nl`;
					let body = {
						nombre: values.nombre,
						email: values.email,
						tel: values.telefono,
						extra: values.mensaje,
						extra_completo: `${values.mensaje}.slug:${slug}`,
						InfoLeads: 1,
					};

					fetch(reqEndpoint, {
						method: "POST",
						body: JSON.stringify(body),
					}).then(res => {
						//
					});
				}
			})
			.catch(info => {
				console.log("Validate Failed:", info);
				setIsLoading(false);
			});
	};

	const onCancelSimilarsLead = () => {
		setModalState(prevState => ({ ...prevState, similarModal: ModalState.CLOSE, contactLead: ModalState.DEFAULT }));
		reset();
	};

	const onSendSimilarsLead = propertyIds => {
		//const values = form.getFieldsValue();
		const values = {
			email: form.getFieldsValue().email ? form.getFieldsValue().email : 'invitado@mail.com',
			financing_information: form.getFieldsValue().financing_information,
			mensaje: 'Hola, vi esta propiedad en InfoCasas y quiero que me contacten. Gracias.',
			nombre: form.getFieldsValue().nombre ? form.getFieldsValue().nombre : 'Invitado',
			telefono: form.getFieldsValue().telefono ? form.getFieldsValue().telefono : '999999999',
		}
		const leads = [...propertyIds].map(property_id => {
			const input: ContactInput = {
				property_id,
				message: values.mensaje,
				financing_information: values.financing_information,
				type: "PROPERTY",
				source: 11,
			};

			if (
				Router.query.utm_campaign ||
				Router.query.utm_content ||
				Router.query.utm_medium ||
				Router.query.utm_source
			) {
				input.utm_args = {};
				if (Router.query.utm_campaign) {
					input.utm_args.utm_campaign = Router.query.utm_campaign;
				}
				if (Router.query.utm_content) {
					input.utm_args.utm_content = Router.query.utm_content;
				}
				if (Router.query.utm_medium) {
					input.utm_args.utm_medium = Router.query.utm_medium;
				}
				if (Router.query.utm_source) {
					input.utm_args.utm_source = Router.query.utm_source;
				}
			}

			return contactMutation({
				variables: {
					input,
				},
			});
		});

		Promise.all(leads)
			.then(_ => {
				CallbackMessage({ message: "¡Tu consulta fue enviada con éxito!" });
			})
			.catch(err => {
				CallbackMessage({
					message: "Ha ocurrido un error",
					description: "Hubo un error. Vuelva a intentarlo.",
					type: "error",
				});
			})
			.finally(() => {
				setModalState((prevState) => ({ ...prevState, similarModal: ModalState.CLOSE }));
				reset();
			});
	};

	const MessageSuccessful = ({ message, checkcircle = false }) => {
		return (
			<>
				{checkcircle ? (
					<Row justify={"center"} style={{ textAlign: "center" }}>
						<Col span={24}>
							<CheckCircleTwoTone
								twoToneColor="#52c41a"
								style={{ fontSize: "25px" }}
							/>
						</Col>
					</Row>
				) : (
					<Typography.Title
						level={4}
						style={{
							color: theme.colors.successColor,
							margin: 0,
							textAlign: "center",
						}}>
						{"Consulta Enviada"}
					</Typography.Title>
				)}

				<Typography.Text
					style={{ textAlign: "center", width: "100%", display: "block" }}
					strong={checkcircle}>
					{message}
				</Typography.Text>
			</>
		);
	};

	return (
		<>
			<Form
				form={form}
				name={"leadForm_" + identifier}
				initialValues={{
					nombre: user.data?.me?.name,
					telefono: user.data?.me?.phone,
					email: user.data?.me?.email,
					mensaje: defaultMessage,
					financing_information: false,
				}}
				labelCol={{ span: 0 }}
				scrollToFirstError
				validateMessages={validateMessages}>
				<Row gutter={12}>
					<Col span={11}>
						<Form.Item
							name="nombre"
							label={"Nombre"}
							hasFeedback
							rules={validateRules.nombre}>
							<Input
								className="secondary"
								placeholder={"Nombre"}
								disabled={disabled}
							/>
						</Form.Item>
					</Col>
					<Col span={13}>
						<Form.Item
							name="telefono"
							label={"Teléfono"}
							rules={validateRules.telefono}>
							<Input
								className="secondary"
								placeholder={"Teléfono"}
								disabled={disabled}
							/>
						</Form.Item>
					</Col>
				</Row>
				<Form.Item name="email" label={"Email"} hasFeedback rules={validateRules.email}>
					<Input
						className="secondary"
						disabled={disabledEmail || disabled}
						placeholder={"Email"}
					/>
				</Form.Item>
				<Form.Item rules={validateRules.mensaje} label={"Mensaje"} name="mensaje">
					<TextArea
						className="secondary"
						rows={showCTA ? 3 : 5}
						autoSize={showCTA ? { minRows: 3, maxRows: 3 } : { minRows: 5, maxRows: 5 }}
						placeholder={"Escribe tu consulta"}
						disabled={disabled}
					/>
				</Form.Item>

				{country_code !== "BR" && country_code !== "ce3" && !onlyConsult && (
					<Form.Item name="financing_information" valuePropName="checked">
						<Checkbox disabled={disabled}>
							{"Quiero info. sobre financiamiento"}
						</Checkbox>
					</Form.Item>
				)}

				<Form.Item>
					<LeadButtons
						id={id}
						mode={mode}
						disabled={disabled}
						queryRouter={queryRouter}
						forceState={modalState.contactLead}
						onPhoneClick={() => {
							setModalState(prevState => ({
								...prevState,
								similarModal: ModalState.OPEN,
								contactLead: ModalState.CLOSE
							}));
						}}
						onWpClick={() => {
							setModalState(prevState => ({
								...prevState,
								similarModal: ModalState.OPEN,
								contactLead: ModalState.CLOSE
							}));
						}}
						onlyConsult={onlyConsult}>
						<Button
							type="primary"
							loading={isLoading}
							disabled={
								formCompleted || disabled || isSendedConsultation.sendConsultation
							}
							className="btn-send-lead"
							onClick={submitForm}>
							{formCompleted
								? "Enviado"
								: isLoading
									? "Enviando"
									: "Enviar Consulta"}
						</Button>
					</LeadButtons>
				</Form.Item>
			</Form>

			{showCTA && country_code !== "BR" && (
				<>
					<Row gutter={12}>
						<Col span={24}>
							{country_code !== "ce3" && (
								<Button
									ref={bell}
									htmlType="button"
									icon={<DollarOutlined className="cta-share-icon" />}
									className="btn-send-cta secondary"
									onClick={() => setTypeCTA(1)}
									disabled={disabled || isSendedConsultation.lowerPrice}>
									{"Avisame cuando baje de precio"}
								</Button>
							)}
							<Button
								htmlType="button"
								icon={
									country_code === "ce3" ? (
										<PhoneFilled className="cta-share-icon" />
									) : (
										<PhoneOutlined className="cta-share-icon" />
									)
								}
								className="btn-send-cta secondary"
								onClick={_ => setTypeCTA(2)}
								disabled={disabled || isSendedConsultation.wantedCall}>
								{"Quiero que me llamen"}
							</Button>
							{country_code !== "ce3" && (
								<Button
									htmlType="button"
									icon={<CalendarOutlined className="cta-share-icon" />}
									className="btn-send-cta secondary"
									onClick={_ => setTypeCTA(3)}
									disabled={disabled || isSendedConsultation.scheduleVisit}>
									{"Agendar Visita"}
								</Button>
							)}
						</Col>
					</Row>
				</>
			)}

			{modalState.similarModal == ModalState.OPEN && (
				<>
					<RTBhouse page="ficha" data={[leadID, id]} />
					<Modal
						className="similar-lead-modal"
						visible
						onCancel={onCancelSimilarsLead}
						width={formType || isInListing ? 420 : 1024}
						maskClosable={false}
						keyboard={false}
						footer={null}>
						{formType || isInListing ? (
							<MessageSuccessful
								message={
									isInListing
										? "¡Tu mensaje fue enviado al anunciante!"
										: "¡Consulta express enviada con éxito!"
								}
								checkcircle
							/>
						) : (
							<SimilarsLead
								id={id}
								mode={mode}
								onSend={onSendSimilarsLead}
								onCancel={onCancelSimilarsLead}
							/>
						)}
					</Modal>
				</>
			)}
		</>
	);
};









